/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Area_AbdomenInputs */

const en_us2_profile_editors_pain_area_abdomen = /** @type {(inputs: Profile_Editors_Pain_Area_AbdomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abdomen`)
};

const pt_br2_profile_editors_pain_area_abdomen = /** @type {(inputs: Profile_Editors_Pain_Area_AbdomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abdômen`)
};

const es_419_profile_editors_pain_area_abdomen = /** @type {(inputs: Profile_Editors_Pain_Area_AbdomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abdomen`)
};

const pt_pt2_profile_editors_pain_area_abdomen = /** @type {(inputs: Profile_Editors_Pain_Area_AbdomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abdómen`)
};

const fr_fr2_profile_editors_pain_area_abdomen = /** @type {(inputs: Profile_Editors_Pain_Area_AbdomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abdomen`)
};

const de_de2_profile_editors_pain_area_abdomen = /** @type {(inputs: Profile_Editors_Pain_Area_AbdomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bauch`)
};

const it_it2_profile_editors_pain_area_abdomen = /** @type {(inputs: Profile_Editors_Pain_Area_AbdomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Addome`)
};

/**
* | output |
* | --- |
* | "Abdomen" |
*
* @param {Profile_Editors_Pain_Area_AbdomenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_area_abdomen = /** @type {((inputs?: Profile_Editors_Pain_Area_AbdomenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Area_AbdomenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_area_abdomen(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_area_abdomen(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_area_abdomen(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_area_abdomen(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_area_abdomen(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_area_abdomen(inputs)
	return en_us2_profile_editors_pain_area_abdomen(inputs)
});
export { profile_editors_pain_area_abdomen as "profile-editors.pain_area_abdomen" }